export default __webpack_public_path__ + "static/media/Big-Data-EN.5c67c899.jpg";